import { render, staticRenderFns } from "./SubscriptionRequired.vue?vue&type=template&id=f3796110&"
import script from "./SubscriptionRequired.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports